import { z } from "zod";

import { OrderEntity, OrderServicePorts } from "~/entities/order";

const zBaseSchema = OrderEntity.zSchema
  .omit({
    number: true,
    status: true,
    payment: true,
    cost: true,
    createdAt: true,
  })
  .extend({
    from: OrderEntity.zSchema.shape.from.extend({
      floor: z.coerce.number().pipe(OrderEntity.zSchema.shape.from.shape.floor.unwrap()),
      floorArea: z.coerce.number().pipe(OrderEntity.zSchema.shape.from.shape.floorArea.unwrap()),
      numberOfRooms: z.coerce
        .number()
        .pipe(OrderEntity.zSchema.shape.from.shape.numberOfRooms.unwrap()),
    }),
    to: OrderEntity.zSchema.shape.to.extend({
      floor: z.coerce.number().pipe(OrderEntity.zSchema.shape.to.shape.floor.unwrap()),
      floorArea: z.coerce.number().pipe(OrderEntity.zSchema.shape.to.shape.floorArea.unwrap()),
      numberOfRooms: z.coerce
        .number()
        .pipe(OrderEntity.zSchema.shape.to.shape.numberOfRooms.unwrap()),
    }),
    contactPerson: OrderServicePorts.ProviderIos.Create.zIn.shape.contactPerson,
    services: z.array(
      OrderEntity.zSchema.shape.services.element
        .pick({
          id: true,
        })
        .extend({
          quantity: OrderEntity.zSchema.shape.services.element.shape.quantity.unwrap(),
        }),
    ),
  });
type BaseSchema = z.infer<typeof zBaseSchema>;

type Params = {
  checkMoveIsScheduledFor?: boolean | undefined;
};

function zSchema({ checkMoveIsScheduledFor = true }: Params) {
  return zBaseSchema.extend({
    moveIsScheduledFor: checkMoveIsScheduledFor
      ? OrderServicePorts.ProviderIos.Create.zIn.shape.moveIsScheduledFor
      : OrderServicePorts.ProviderIos.Update.zIn.shape.moveIsScheduledFor.unwrap(),
  });
}
type Schema = z.infer<ReturnType<typeof zSchema>>;

export { zBaseSchema, zSchema };
export type { BaseSchema, Schema };
